import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var ConflictError = function ConflictError(error) {
    _classCallCheck(this, ConflictError);

    var _ref = error || {},
        statusCode = _ref.statusCode,
        message = _ref.message,
        response = _ref.response;

    this.code = statusCode;
    this.message = message;
    this.response = response;
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/conflict.js
// module id = ./src/abstractions/errors/conflict.js
// module chunks = 34